import { render, staticRenderFns } from "./content-panel.vue?vue&type=template&id=64a95180&scoped=true"
import script from "./content-panel.vue?vue&type=script&lang=js"
export * from "./content-panel.vue?vue&type=script&lang=js"
import style0 from "./content-panel.vue?vue&type=style&index=0&id=64a95180&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a95180",
  null
  
)

export default component.exports